import script from "./SalesByProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesByProducts.vue?vue&type=script&setup=true&lang=ts"

import "./SalesByProducts.vue?vue&type=style&index=0&id=73286ac0&lang=css"

const __exports__ = script;

export default __exports__